var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.label,"label-for":_vm.id}},[_c('b-form-input',{attrs:{"id":_vm.id,"value":_vm.value,"readonly":_vm.readonly}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }